<div class="hmt__caja">
  <table class="hmt">
    <thead>
      <tr>
        <th scope="col" class="hmt__tarea">Tarea</th>
        @for (r of rubros; track r.id) {
          <th scope="col">{{ r.nombre }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (t of tareas; track $index) {
        <tr>
          <th scope="row" class="hmt__tarea">
            <span class="hmt__id">{{ t.id }}</span>
            <span class="hmt__nombre">{{ t.nombre }}</span>
          </th>
          @for (r of rubros; track r.id) {
            @let v = valor(t, r.id);
            <td [attr.data-nivel]="nivel(v)">
              @if (v !== null) {
                {{ v | number: "1.1-1" }}
              } @else {
                <span class="hmt__na">no aplica</span>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
<p class="hmt__leyenda">
  <span data-nivel="alto">≥ 90</span>
  <span data-nivel="medio">≥ 75</span>
  <span data-nivel="bajo">&lt; 75</span>
  <span data-nivel="na">no aplica</span>
</p>
